export default function CardFailureConfirmationTimedOutExtra({
  onTimeOutConfirmed,
  originalAmount,
  pedName,
}: {
  onTimeOutConfirmed: (confirmed: boolean) => void;
  originalAmount: number;
  pedName: string;
}) {
  const priceFormatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  });
  return (
    <div className="pos-modal pos-modal_role_sign-in">
      <div className="pos-modal__content">
        <div className="pos-sign-in js-sign-in">
          <div className="pos-sign-in__header">
            <h2 className="pos-sign-in__title">Timed Out Confirmation</h2>
          </div>
          <div className="pos-sign-in__info">
            <p className="pos-sign-in__label">
              You are now confirming that the payment has failed. Please check the card machine again, are you sure the payment failed for{' '}
              {priceFormatter.format(originalAmount)}?
              <br />
              <br />
              <b>Amount</b>: {priceFormatter.format(originalAmount)}
              <br />
              <b>Card Machine</b>: {pedName}
              <br />
              <br />
              Please check the card machine again, are you sure the payment failed for {priceFormatter.format(originalAmount)}?
            </p>
          </div>
          <div className="pos-sign-in__actions">
            <button
              style={{ marginRight: '10px', width: '40%' }}
              className="pos-sign-in__action"
              type="button"
              onClick={() => onTimeOutConfirmed(true)}
            >
              Confirm Failed
            </button>
            <button style={{ width: '40%' }} className="pos-sign-in__action" type="button" onClick={() => onTimeOutConfirmed(false)}>
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
